import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';
import { CommonService } from 'src/app/shared/common.service';

@Component({
  selector: 'app-item-master',
  templateUrl: './item-master.component.html',
  styleUrls: ['./item-master.component.scss'],
  providers: [DataService]
})
export class ItemMasterComponent implements OnInit {
  ItemMasterForm: UntypedFormGroup;
  subcategoryList: any;
  displayedColumns = ['SubCategoryName', 'ItemName', 'Status', 'Edit'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  viewdata: any;
  statusList: any;
  ItemDataSource: any[];
  pageEvent: PageEvent;
  Ispanelshow: any;
  IsAddpanelshow: any;
  @ViewChild('TABLE') table: ElementRef;


  constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder, private status: HTTPStatus, private error: AppErrorHandler, public _global: Global, public _com: CommonService) {

  }

  ngOnInit() {
    //this.paginator.showFirstLastButtons = true;
    this.Ispanelshow = false;
    this.IsAddpanelshow = false;
    //this.paginator.pageSize = this._global.RecordSize;
    this.ItemMasterForm = this._fb.group({
      ItemId: [''],
      SelectedsubCategory: [[], Validators.required],
      ItemName: ['', Validators.required],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      IsActive: [''],
      StatusSearch: [''],
      SubCategorySearch: [''],
      SubCategoryId: [''],
    });
    this.BindSubCategoryList();
    this.SearchRecord();
    this.BindStatusList();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }
  SearchRecord() {
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewItemList();
  }

  BindSubCategoryList() {
    this._dataservice.GetData('Category/GetSubCategory/').subscribe(result => {
      this.subcategoryList = result;
    });
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.ItemMasterForm.controls).forEach(field => {
      const control = this.ItemMasterForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.ItemMasterForm.controls[controlName];
  }


  submitdata() {
    this.GetFormControls('SelectedsubCategory').setValidators([Validators.required]);
    this.GetFormControls('SelectedsubCategory').updateValueAndValidity();
    this.GetFormControls('ItemName').setValidators([Validators.required]);
    this.GetFormControls('ItemName').updateValueAndValidity();
    if (!this.ItemMasterForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/Saveitem/', this.ItemMasterForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.ClearData();
        this.ViewItemList();
        this.GetFormControls('SelectedsubCategory').clearValidators();
        this.GetFormControls('SelectedsubCategory').updateValueAndValidity();
        this.GetFormControls('ItemName').clearValidators();
        this.GetFormControls('ItemName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => {
        this.status.setHttpStatus(false);
      });
  }

  ClearData() {
    this.ItemMasterForm.controls.SelectedsubCategory.setValue('');
    this.ItemMasterForm.controls.ItemName.setValue('');
    this.ItemMasterForm.controls.IsActive.setValue('');
    this.ItemMasterForm.patchValue({
      ItemId: 0
    });
  }

  ViewItemList() {
    this.ItemMasterForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.ItemMasterForm.controls.PageSize.setValue(this._global.RecordSize);
    debugger;
    this.ItemMasterForm.patchValue({
      SubCategoryId: this.ItemMasterForm.controls.SubCategorySearch.value.SubCategoryId,
      IsActive: this.ItemMasterForm.controls.StatusSearch.value.StatusId,
    });
    this._dataservice.PostData('Category/GetItemList/', this.ItemMasterForm.value).subscribe(result => {
      this.viewdata = result;

      if (this.viewdata != null && this.viewdata.length > 0) {
        this.ItemDataSource = this.viewdata;
        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);

      } else {
        this.ItemDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }


  Relod() {
    window.location.reload();
  }

  rowclickdata(row: any) {
    var dataitem;
    dataitem = this.ItemDataSource.filter(x => x.ItemId == row);
    this.ItemMasterForm.patchValue({
      ItemId: dataitem[0]['ItemId'],
      ItemName: dataitem[0]['ItemName'],
      IsActive: dataitem[0]['IsActive'],
      SelectedsubCategory: this.BindSpecialization(dataitem[0]['SubCategoryName'])
    });
  }

  BindSpecialization(sf) {
    let p = this.subcategoryList.filter(x => x.SubCategoryName == sf);
    return p[0];
  }

  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewItemList();
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Item_Master.xlsx');

  }

  Export() {
    this.status.setHttpStatus(true);
    this._com.ExportToExcelItem(this.ItemMasterForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Item_Master.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  ResetData() {
    this.ItemMasterForm.reset({
      "SubCategorySearch": "",
      "StatusSearch": ""
    })
    this.GetResult();


  }

  Exit() {

    if (this.ItemMasterForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }

  }

  BindStatusList() {
    this._dataservice.GetData('Category/GetStatus/').subscribe(result => {

      this.statusList = result;
      debugger;
    });
  }

  GetResult() {

    this.SearchRecord();


  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;

  }

  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;

  }


}
